import React from "react";

// Lightweight markdown renderer (headings, bold, bullets, paragraphs).
function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={i} className="font-semibold text-foreground">{p.slice(2, -2)}</strong>
    ) : (
      <React.Fragment key={i}>{p}</React.Fragment>
    )
  );
}

export default function Markdown({ children, className = "" }) {
  const lines = (children || "").split("\n");
  const blocks = [];
  let list = [];

  const flush = () => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`} className="list-disc pl-5 space-y-1 my-2 text-sm text-muted-foreground">
          {list.map((li, i) => <li key={i}>{inline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (!line) { flush(); return; }
    if (line.startsWith("### ")) { flush(); blocks.push(<h4 key={idx} className="font-display font-semibold text-base mt-4 mb-1 text-foreground">{inline(line.slice(4))}</h4>); }
    else if (line.startsWith("## ")) { flush(); blocks.push(<h3 key={idx} className="font-display font-semibold text-lg mt-4 mb-1 text-foreground">{inline(line.slice(3))}</h3>); }
    else if (line.startsWith("# ")) { flush(); blocks.push(<h2 key={idx} className="font-display font-bold text-xl mt-4 mb-2 text-foreground">{inline(line.slice(2))}</h2>); }
    else if (/^[-*]\s+/.test(line)) { list.push(line.replace(/^[-*]\s+/, "")); }
    else { flush(); blocks.push(<p key={idx} className="text-sm leading-relaxed text-muted-foreground my-1.5">{inline(line)}</p>); }
  });
  flush();

  return <div className={className}>{blocks}</div>;
}
